'use strict'
import { request } from '../../plugins/http'

export default async (companyId) => {
    return await request.get('/produto', {params:{companyId:companyId}})
}